<template>
  <div>
    <top-bar :user="this.user" />
    <MenuItems :user="this.user" :menuSelected="{ manageAdmins: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ manageAdmins: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
      }">
        <div v-if="this.selectedPerson">
          <h3 class="return">
            <a href="#" @click="selectedPerson = null">
              <font-awesome-icon icon="chevron-left" />
              <span>{{ $t("backButtonLabel") }}</span>
            </a>
          </h3>
          <admin-edit :person="this.selectedPerson" />
        </div>
        <div v-else>
          <h1>{{ $t("managementTitle") }}</h1>
          <p>{{ $t("managementShortDesc") }}</p>
          <br />

          <div>
            <h3>{{ $t("browsePersonsLabel") }}</h3>
            <div class="persons-content">
              <friend-case v-for="(entry, index) in persons" :key="index" :person="entry" :admin=true
                @selectPerson="selectPerson" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.personsError !== null">
          <br />
          <p v-html="$t('error_' + this.personsError.code)"></p>
        </div>
        <div v-else>
          <br />
          <p>{{ $t("personModifySuccess") }}</p>
        </div>
      </div>
    </div> -->
    <!-- <modal-loading /> -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";
import FriendCase from "../components/fragments/FriendCase.vue";
import AdminEdit from "@/components/company/AdminEdit.vue";
import httpServiceCustomer from "@/http/http-customer.js";
import ModalLoading from "@/components/fragments/ModalLoading.vue";

export default {
  name: "Administrators",
  components: { TopBar, MenuItems, FriendCase, AdminEdit, ModalLoading },
  data() {
    return {
      user: null,
      persons: null,
      selectedPerson: null,
      perPage: 10000,
      currentPage: 1,
      sortField: "lname",
      sortDirection: "asc",
      personsError: null,
    };
  },
  methods: {
    getPersons() {
      this.persons = null;
      var persons = "?admin=Y";
      persons +=
        "&per_page=" +
        this.perPage +
        "&page=" +
        this.currentPage +
        "&sort=" +
        this.sortDirection;
      if (this.sortDirection === "desc") {
        persons += "&desc=" + this.sortField;
      } else {
        persons += "&asc=" + this.sortField;
      }
      httpServiceCustomer.customerService
        .searchPersons(persons, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.personsError = {
            code: error.response.data,
            description: "Error fetching persons",
          };
        })
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            this.persons = response.data;
            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.personsError = {
              code: response.data,
              description: "Error fetching persons",
            };
          } else {
            this.personsError = { description: response.description };
          }
        });
    },
    selectPerson(person) {
      this.selectedPerson = person;
    },
  },
  mounted() {
    this.getPersons();
  },
  created() {
    this.user = this.getUser();
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.persons-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>
